/* The action button aligns with the close button */
.action-button > *:first-child {
    padding: 0 12px;
}

/* The action button's svg is dark grey on hover */
.action-button > *:first-child *:hover {
    fill: var(--grey-dk);
}
